exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader-backdrop {\n  background: #5c5c5c;\n  height: 100%;\n  left: 0;\n  opacity: .6;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 2051; }\n\n.preloader-container {\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 2052; }\n\n.preloader {\n  position: absolute;\n  text-align: center;\n  top: 40%;\n  width: 100%; }\n\n.preloader img {\n    width: 80px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/preloader/preloader.component.scss
// module id = ../../../../../src/app/core/components/preloader/preloader.component.scss
// module chunks = main